import { render } from "./TaskProgressBar.vue?vue&type=template&id=ed8e6b7a"
import script from "./TaskProgressBar.vue?vue&type=script&lang=js"
export * from "./TaskProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__